import { LoginPage } from "./login";

/**
 * F-CAPTURE-005 — where a full sign-out comes to rest. Suite's /logout returns
 * the browser here after ending the Suite session. It deliberately does not
 * bounce anywhere on its own: an automatic bounce is what used to sign people
 * straight back in. Outside the AuthGate, so it never triggers an SSO redirect.
 */
export function SignedOutPage() {
  return <LoginPage title="You're signed out of Skarn" cta="Sign in again" />;
}
